import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  messages: [],
  total_pages: 0,
  total_results: 0
};
export const useMessageListFetch = () => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue,setSearchValue] = useState('');
  const [includeInactive,setIncludeInactive] = useState(false)
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
  
  console.log(searchValue)
  const fetchMessageList = async(searchValue)=>{
    try {
      setLoading(true);
      setError(false);
     console.log("binne fetchTransactionslist")
      const data = await API.fetchMessages(searchValue,"",includeInactive,"",accessToken)
     
      console.log(data.messages)
      setState({  
        ...data
        
      }
      )

      setLoading(false)
      setTrigger(false)

    } catch (error) {
      console.log(error)
      setError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setState(initialState)
    fetchMessageList(searchValue)
  },[searchValue,trigger,includeInactive]);

return{state,loading,error,setSearchValue,setIncludeInactive,setLoading,setTrigger};


};
